const deviceSize = {
  tablet: 1199.98,
  mobile: 767.98,
};

const vars = {
  colors: {
    crusta: '#EC8562',
    orange: '#EE6131',
    smoke: '#F3F3F3',
    smokeTranslucent: '#F3F3F399',
    aluminium: '#7B8085',
    nero: '#212121',

    black: '#000',
    white: '#fff',
    red: '#D7181F',
    green: '#006400',
    blue: '#00008B',
    yellow: '#FDB810',
    brown: '#35170C',
    grey: '#434750',
    darkGrey: '#4F525A',
    middleGrey: '#A7A8AC',
    lightGrey: '#F3F3F3',
    darkBlue: '#364657',
    grey5: '#E0E0E0',
    grey4: '#BDBDBD',
    grey3: '#323232',
  },
  fonts: {
    h1_size: 36,
    h2_size: 36,
    h3_size: 22,
    h4_size: 18,
    h5_size: 16,
    h6_size: 14,
    h7_size: 10,

    h1_lineHeight: 54,
    h2_lineHeight: 54,
    h3_lineHeight: 22,
    h4_lineHeight: 18,
    h5_lineHeight: 20,
    h6_lineHeight: 17,
    h7_lineHeight: 12,

    h1_mobile_size: 24,
    h2_mobile_size: 20,
    h3_mobile_size: 17,
    h4_mobile_size: 15,
    h5_mobile_size: 12,
    h6_mobile_size: 10,
    h7_mobile_size: 10,

    h1_mobile_lineHeight: 32,
    h2_mobile_lineHeight: 28,
    h3_mobile_lineHeight: 24,
    h4_mobile_lineHeight: 20,
    h5_mobile_lineHeight: 20,
    h6_mobile_lineHeight: 20,
    h7_mobile_lineHeight: 20,
  },
  media: {
    tablet: `(max-width: ${deviceSize.tablet}px)`,
    mobile: `(max-width: ${deviceSize.mobile}px)`,
  },
};

export default vars;
